const SAFE_OBSERVABILITY_RELEASE_PATTERN =
  /^[A-Za-z0-9_-]+(?:\/[A-Za-z0-9_.-]+)*$/;

export function isSafeObservabilityRelease(value: unknown): value is string {
  if (
    typeof value !== "string" ||
    value.length < 1 ||
    value.length > 200 ||
    !SAFE_OBSERVABILITY_RELEASE_PATTERN.test(value)
  ) {
    return false;
  }

  const firstSegment = value.split("/", 1)[0];
  if (!firstSegment) return false;
  return firstSegment.toLowerCase() !== "localhost";
}
